var React = require('react');

function ExclamationCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#FF4B4B","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M14.667 8a6.668 6.668 0 0 1-6.675 6.667c-3.68 0-6.659-2.99-6.659-6.667 0-3.677 2.979-6.667 6.659-6.667A6.668 6.668 0 0 1 14.667 8zM8 10.267v.333M8 5.2V8"})));
}

ExclamationCircle.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ExclamationCircle;

ExclamationCircle.default = ExclamationCircle;
